import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';
import { JsonReturn } from './interface/generic-interface';

@Injectable()
export class RouteService {
  private _currentPoints: any;
  public empresa: any;
  public retornarOrigem: boolean = false;
  public pointBarrier: any[] = []

  SelectedClients: any = [];
  CurrentRoute: any;
  CurrentRouteGraphic: any;
  PontoInicial: any;
  contador: number = 0;
  checkAll: any;
  valorFrete: any = '';
  cbChecked = false;
  exibeAlerta = false;
  nomeCliente = '';

  constructor(
    private conService: ApiConService
  ) { }

  async getPointsRoute() {
    try {
    }
    catch (Error) {
      console.log("CATCH________getPointsRoute");
      console.log(Error);
    }
  }

  async ultimaPosicao() {
    try {
      const response: JsonReturn = await this.conService.patch('DCcoordenadas/ultimaPosicao/0');

      return response.response;
    }
    catch (Error) {
      console.log("CATCH________ultimaPosicao");
      console.log(Error);
    }
  }

  async dadosEmpresa(codigoEmpresa: any) {
    try {
      const response: JsonReturn = await this.conService.patch('empresa/' + codigoEmpresa);
      this.empresa = response.response[0];

      return this.empresa;
    }
    catch (Error) {
      console.log("CATCH________dadosEmpresa");
      console.log(Error);
    }
  }

  private indexItem(cdClient: any) {
    if (this.SelectedClients.length == 0) { return -1; }
    for (let i = 0, len = this.SelectedClients.length; i < len; i++) {
      if (this.SelectedClients[i].cd_clien == cdClient) { return i; }
    }
    return -1;
  }

  public getItem(cdClient): any {
    for (let i = 0, len = this._currentPoints.length; i < len; i++) {
      if (this._currentPoints[i].cd_clien == cdClient) { return this._currentPoints[i]; }
    }
    return null;
  }

  fixOrder() {
    for (let i = 0, len = this.SelectedClients.length; i < len; i++) { this.SelectedClients[i].order = i + 1; }
  }

  toggleSelect(cdClient: any): any {
    let index = this.indexItem(cdClient);
    let item: any;
    let clientes: number;

    if (index != -1) {
      item = this.SelectedClients[index];
      item.selected = false;
      this.SelectedClients.splice(index, 1);
      this.fixOrder();
    }
    else {
      item = this.getItem(cdClient);

      if (item == null) { return null; }

      item.selected = true;
      item.order = this.SelectedClients.length + 1;

      this.SelectedClients[this.SelectedClients.length] = item;
    }

    return item;
  }

  private updateSequence(stops: any[], custoKM: number) {
    let aux: any[] = [];

    // Calculo do custo de cada ponto de parada
    let qtdePontosParada = stops.length - 1;

    for (var i = 0; i < stops.length; i++) {
      let index = this.indexItem(stops[i].attributes.Name);

      if (index != -1) {
        let distancia = stops[i].attributes.Cumul_Kilometers;
        let item = this.SelectedClients[index];

        this.SelectedClients.splice(index, 1);
        if (item.order != i) { item.order = i; }
        aux[i - 1] = item;

        if (i == 1) {
          stops[i].attributes.percCusto = distancia / qtdePontosParada;
        }
        else if (i > 1) {
          distancia -= stops[i - 1].attributes.Cumul_Kilometers;
          stops[i].attributes.percCusto = distancia / (qtdePontosParada - (i - 1)) + stops[i - 1].attributes.percCusto;
        }

        item.custo = stops[i].attributes.percCusto * custoKM;
      }
    }

    this.SelectedClients = aux;
  }

  updateRoute(router: any, custoTotalKM: number) {
    this.updateSequence(router.result.routeResults[0].stops, custoTotalKM);
  }
}
